import React from 'react'
import moment from 'moment'
import { CuiButton } from 'front-lib'

interface FooterProps {
  restartAction: () => void
  text: string
  conditionsText: string
  isNewLandingEnabled?: boolean
}

const Footer: React.FC<FooterProps> = ({
  restartAction,
  text,
  conditionsText,
  isNewLandingEnabled = false
}) => (
  <div className={`footerContainer ${isNewLandingEnabled ? 'newLanding' : ''}`}>
    <div className="container">
      <p
        className="bannerTextBold"
        dangerouslySetInnerHTML={{ __html: text }}
      />
      <div className="textInfoContainer">
        <p className="textInfoFooter">
          You can change your plan, pause, or cancel at any time.
        </p>
        <p className="textInfoFooter">
          {conditionsText ??
            `Offer will only apply to deliveries within the first 4 consecutive weeks from the day of activation.`}
        </p>
      </div>
      <div className="action-button-banner">
        <CuiButton color="light" fill="solid" onClick={restartAction}>
          Resubscribe Now
        </CuiButton>
      </div>
    </div>

    <p className="textFooter">
      &copy; {moment().format('Y')} CookUnity | support@cookunity.com | 1
      888.221.8187
    </p>
  </div>
)

export default Footer
